import genericAvatar from "assets/images/generic_avatar.jpg";
import { ErrorModal, PageContainer } from "components";
import { variants } from "components/AnimatedRoutes";
import { FacultyContactInfo, FacultySecondaryInfo } from "components/reusables";
import { AddEditFacultyModal } from "components/reusables/AddEditModals/AddEditFacultyModal";
import { motion } from "framer-motion";
import React, { useCallback, useState } from "react";
import { useAsync } from "react-async";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import Img from "react-cool-img";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { getFacultyStory } from "services";
import { generateFullName, URLPaths } from "utilities";

export function PictureWallFacultyStoryDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [isShowingEditFacultyModal, setIsShowingEditFacultyModal] = useState(false);
  const promiseFn = useCallback(() => getFacultyStory(id), [id]);
  const { data, error, isPending } = useAsync({ promiseFn });
  const thisFacultyMember = data;
  const history = useHistory();

  const handleClick = () => {
    history.goBack();
  };

  if (!thisFacultyMember && !isPending) return <Redirect to={URLPaths.pictureWall} />;

  return (
    <motion.div
      variants={variants}
      initial="jobenter"
      animate="jobcenter"
      exit="jobexit"
      transition={{
        x: { bounce: 0, duration: 0.5, type: "spring" },
      }}
    >
      <PageContainer>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            borderColor: "#000000",
            borderRadius: "10px",
            padding: "45px",
            paddingTop: "40px",
            position: "relative",
            top: "-45px",
          }}
        >
          {isPending ? (
            <Spinner animation="border" />
          ) : (
            thisFacultyMember && (
              <Row>
                <Col xs={3}>
                  <Img
                    src={thisFacultyMember.photoUrl || ""}
                    placeholder={genericAvatar}
                    alt={`${thisFacultyMember.firstName} ${thisFacultyMember.lastName}`}
                    width="100%"
                    loading="lazy"
                    className="img-circle"
                  />
                  <hr />
                  <FacultySecondaryInfo facultyMember={thisFacultyMember} direction="column" />
                  <hr />
                  <FacultyContactInfo facultyMember={thisFacultyMember} />
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <h1>
                        {generateFullName(thisFacultyMember.firstName, thisFacultyMember.lastName)}
                      </h1>
                      <span>{`Faculty Since ${thisFacultyMember.facultySince}`}</span>
                    </Col>

                    <Col xs="auto">
                      <Button onClick={handleClick} variant="outline-danger">
                        Go Back
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col xs={8}>
                      <h4>About</h4>
                      <p className="p-breaks">{thisFacultyMember.bio}</p>
                    </Col>
                    <Col xs={4}>
                      {(thisFacultyMember.quotes || []).length > 0 && (
                        <>
                          <h4>Quotes</h4>
                          <Card className="quotes">
                            <Card.Body>
                              {thisFacultyMember.quotes?.map(quote => (
                                <AlumQuote key={quote} quote={quote} />
                              ))}
                            </Card.Body>
                          </Card>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
          )}
          <ErrorModal error={error} />
        </div>

        {!!thisFacultyMember && (
          <AddEditFacultyModal
            show={isShowingEditFacultyModal}
            setShow={setIsShowingEditFacultyModal}
            currentFaculty={thisFacultyMember}
          />
        )}
      </PageContainer>
    </motion.div>
  );
}

interface AlumQuoteProps {
  quote: string;
}

function AlumQuote({ quote }: AlumQuoteProps): JSX.Element {
  return (
    <div className="quote d-flex flex-row">
      <span>&quot;{quote}&quot;</span>
    </div>
  );
}
